import React, { ReactChildren, ReactElement } from "react";

import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import ConditionalFormField, {
  ConditionalFormFieldProps,
} from "@app/component/ConditionalFormField";

const getFieldMatcher = (field: IField) => {
  return (
    node: ReturnType<ReactChildren["toArray"]>[number]
  ): node is ReactElement<ConditionalFormFieldProps> => {
    if (!React.isValidElement(node)) {
      return false;
    }

    if (
      node.type === ConditionalFormField &&
      (typeof node.props?.children === "function" ||
        React.Children.count(node.props?.children) === 1)
    ) {
      const { feature, fieldName } = (node as ReactElement<ConditionalFormFieldProps>).props;
      const matchesName = Array.isArray(fieldName)
        ? fieldName.includes(field.name)
        : isDefined(fieldName)
          ? fieldName === field.name
          : true;
      const matchesFeature = isDefined(feature) ? field.hasFeature(feature) : true;
      return matchesName && matchesFeature;
    }

    return false;
  };
};

export default getFieldMatcher;
